import React from 'react';
import styled from 'styled-components';
import { SelectDropdown, SelectOption } from '../../components/SelectDropdown';
import { useNegoceFilters } from './NegoceFilters';

/**
 * Shared filter bar for the Négoce Stats section.
 * Shows Campaign, Wine, Sale Type (and optionally Negociant) dropdowns.
 */
export const NegoceFilterBar: React.FC<{ showNegociant?: boolean }> = ({
  showNegociant = false
}) => {
  const {
    campaignId,
    wineId,
    saleTypeId,
    negociantId,
    campaigns,
    wines,
    saleTypes,
    negociants,
    isLoading,
    setCampaignId,
    setWineId,
    setSaleTypeId,
    setNegociantId
  } = useNegoceFilters();

  const campaignOptions: SelectOption[] = campaigns.map((c: any) => ({
    value: c.id,
    label: c.name
  }));

  const wineOptions: SelectOption[] = [
    { value: -1, label: 'All wines' },
    ...wines.map((w: any) => ({ value: w.id, label: w.name }))
  ];

  const saleTypeOptions: SelectOption[] = [
    { value: -1, label: 'All sale types' },
    ...saleTypes.map((s: any) => ({ value: s.id, label: s.name }))
  ];

  const negociantOptions: SelectOption[] = [
    { value: -1, label: 'All négociants' },
    ...negociants.map((n: any) => ({ value: n.id, label: n.name }))
  ];

  return (
    <Bar>
      <SelectDropdown
        options={campaignOptions}
        value={campaignId ?? ''}
        onChange={(val) => setCampaignId(val ? Number(val) : undefined)}
        placeholder="Campaign"
        disabled={isLoading}
      />
      <SelectDropdown
        options={wineOptions}
        value={wineId ?? -1}
        onChange={(val) =>
          setWineId(Number(val) === -1 ? undefined : Number(val))
        }
        placeholder="Wine"
        disabled={isLoading}
      />
      <SelectDropdown
        options={saleTypeOptions}
        value={saleTypeId ?? -1}
        onChange={(val) =>
          setSaleTypeId(Number(val) === -1 ? undefined : Number(val))
        }
        placeholder="Sale type"
        disabled={isLoading}
      />
      {showNegociant && (
        <SelectDropdown
          options={negociantOptions}
          value={negociantId ?? -1}
          onChange={(val) =>
            setNegociantId(Number(val) === -1 ? undefined : Number(val))
          }
          placeholder="Négociant"
          disabled={isLoading}
        />
      )}
    </Bar>
  );
};

const Bar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 24px;
`;
